/**
 * import and init global plugins
 */

import Vue from 'vue'

import globalEventBus from '../plugins/globalEventBus'
import VueI18n from 'vue-i18n'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import FineMq from 'fine-mq'
import Vuelidate from 'vuelidate'
import VueRecaptcha from 'vue-recaptcha'


Vue.use(globalEventBus);
Vue.use(VueAwesomeSwiper);
Vue.use(FineMq);
Vue.use(Vuelidate);
Vue.use(VueI18n);
Vue.use(VueRecaptcha);




// WEBPACK FOOTER //
// ./src/plugins/index.js